module.exports = __webpack_public_path__ + "static/media/test5.0374a1cc.jpg";